import { BaseService } from "./BaseService";

export class PostsService extends BaseService {
  constructor() {
    super("posts");
  }

  async getOne(id: string) {
    return await this.get(`/${id}`);
  }
}